/**
 * New York Numbers + Win 4 draw/sync schedule (official times in Eastern Time).
 * Play windows in the app are Cuba civil time — use `windowsForLotterySource('newyork')`.
 * @see docs/lottery.md
 *
 * Same post-draw sync offset and results-wait block offsets as Florida.
 */
/** Minutes after an official draw when Alea runs auto-sync. */
export const NEW_YORK_RESULTS_SYNC_OFFSET_MINUTES = 10;

export {
  RESULTS_WAIT_BLOCK_OFFSETS,
  RESULTS_WAIT_REOPEN_MINUTES,
} from './floridaSchedule';

export const NEW_YORK_LOTTERY_SCHEDULE = {
  middayDraw: '14:30',
  middaySync: '14:40',
  eveningDraw: '22:30',
  eveningSync: '22:40',
  timezone: 'America/New_York',
} as const;

export type NewYorkDrawSession = 'midday' | 'evening';

export function newYorkDrawWindow(session: NewYorkDrawSession): 'day' | 'night' {
  return session === 'midday' ? 'day' : 'night';
}

export function newYorkSyncCron(session: NewYorkDrawSession): string {
  const [h, m] = (session === 'midday'
    ? NEW_YORK_LOTTERY_SCHEDULE.middaySync
    : NEW_YORK_LOTTERY_SCHEDULE.eveningSync
  ).split(':').map(Number);
  return `${m} ${h} * * *`;
}
